import { ref } from "vue";
import useActivationViber from "@/components/activation/api/useActivationViber";
import useActivationWhatsapp from "@/components/activation/api/useActivationWhatsapp";

export default function () {


    const customStatus = ref('')

    const getCustomStatus = async (number, messenger) => {
        switch (messenger) {
            case "viber":
                const {
                    getStatusActivationViber,
                    statusNumberActivation: statusViber,
                } = useActivationViber();

                await getStatusActivationViber(number)
                customStatus.value = statusViber.value
                break
            case "whatsapp":
                const {
                    getStatusActivationWhatsapp,
                    statusNumberActivation: statusWhatsapp,
                } = useActivationWhatsapp();

                await getStatusActivationWhatsapp(number)
                customStatus.value = statusWhatsapp.value
                break;
            default:
        }
        console.debug('status', customStatus.value)
    }
    return {
        getCustomStatus,
        customStatus,
    };
}
